import { css } from '@emotion/react';

export const buttonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  rowGap: 40
});

export const title = css({
  marginTop: 80,
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px'
});

export const buttonTitle = css({
  fontSize: 32,
  lineHeight: '41.6px',
  fontWeight: '700'
});
